/**
 * 디자인 가이드에 Image로 정리된 항목입니다. img_ 로 시작하는 파일들의 모음입니다.
 * https://www.figma.com/file/lun1D9CzpkoufkINaOHID1/NEXT_Design_System?node-id=3617%3A21666
 */
export enum StaticImageType {
  PolicyRight01 = 'PolicyRight01',
  PolicyRight02 = 'PolicyRight02',
  ProfileStatic = 'ProfileStatic',
  ProfileDormantStatic = 'ProfileDormantStatic',
  ProfileWithdrawalStatic = 'ProfileWithdrawalStatic',
  Thumbnail19PosterStatic = 'Thumbnail19PosterStatic',
  Thumbnail19CardStatic = 'Thumbnail19CardStatic',
  TooltipTailLeftStatic = 'TooltipTailLeftStatic',
  TooltipTailRightStatic = 'TooltipTailRightStatic',
  TooltipTailDownStatic = 'TooltipTailDownStatic',
  TooltipTailUpStatic = 'TooltipTailUpStatic',
  TooltipMoreTailDownStatic = 'TooltipMoreTailDownStatic',
  LogoBiTextL = 'LogoBiTextL',
  LogoBiTextM = 'LogoBiTextM',
  FooterCopyright = 'FooterCopyright',
  FooterMycelebs = 'FooterMycelebs',
  GiftStatic = 'GiftStatic',
  NotificationBiStatic = 'NotificationBiStatic',
  NotificationCashStatic = 'NotificationCashStatic',
  NotificationGiftStatic = 'NotificationGiftStatic',
  NotificationHeartStatic = 'NotificationHeartStatic',
  NotificationCommentStatic = 'NotificationCommentStatic',
  ViewerTutorialEpub01Static = 'ViewerTutorialEpub01Static',
  ViewerTutorialEpub02Static = 'ViewerTutorialEpub02Static',
  ViewerTutorialImage01Static = 'ViewerTutorialImage01Static',
  ViewerTutorialImage02Static = 'ViewerTutorialImage02Static',
  ViewerTutorialTalk01Static = 'ViewerTutorialTalk01Static',
  ViewerTutorialTalk02Static = 'ViewerTutorialTalk02Static',
  PaymentPopularStatic = 'PaymentPopularStatic',
  PaymentAll = 'PaymentAll',
  CouponCashFriendsStatic = 'CouponCashFriendsStatic',
  CouponTvPointStatic = 'CouponTvPointStatic',
  CouponHistoryStatic = 'CouponHistoryStatic',
  Coupon72h = 'Coupon72h',
  CrmCashStatic = 'CrmCashStatic',
  CrmGiftStatic = 'CrmGiftStatic',
  CrmWelcomeStatic = 'CrmWelcomeStatic',
  CashPassVipUnsubcribeStatic = 'CashPassVipUnsubcribeStatic',
  CashPassVipCashStatic = 'CashPassVipCashStatic',
  CashPassVipCardStatic = 'CashPassVipCardStatic',
  CashPassVipDimStatic = 'CashPassVipDimStatic',
  CashPassVipTextStatic = 'CashPassVipTextStatic',
  CashPassVipComplete = 'CashPassVipComplete',
  ExceptionNoticeMStatic = 'ExceptionNoticeMStatic',
  ExceptionBiMStatic = 'ExceptionBiMStatic',
  ExceptionNoticeLStatic = 'ExceptionNoticeLStatic',
  ExceptionBiLStatic = 'ExceptionBiLStatic',
  Age15Static = 'Age15Static',
  Age19Static = 'Age19Static',
  // 네이밍 뒤에 43은 1:1.43 비율을 적었습니다.
  Age19Thumbnail43 = 'Age19Thumbnail43',
  // 네이밍 뒤에 2은 1:2 비율을 적었습니다.
  Age19Thumbnail2 = 'Age19Thumbnail2',
  InstallBannerDaMw = 'InstallBannerDaMw',
  InstallBannerViewerEndMw = 'InstallBannerViewerEndMw',
  InstallMw = 'InstallMw',
  InstallPc = 'InstallPc',
  AppStore = 'AppStore',
  PlayStore = 'PlayStore',
  BillingCheckOn = 'BillingCheckOn',
  BillingCheckOff = 'BillingCheckOff',
  DabannerCashfriendsStatic = 'DabannerCashfriendsStatic',
  ExpandCashfriendsStatic = 'ExpandCashfriendsStatic',
  /**
   * 앱스킴
   */
  AppSchemeGoogleplayPcStatic = 'AppSchemeGoogleplayPcStatic',
  AppSchemeAppstorePcStatic = 'AppSchemeAppstorePcStatic',
  AppSchemeQrLocal = 'AppSchemeQrLocal',
  AppSchemeQrDev = 'AppSchemeQrDev',
  AppSchemeQrTest = 'AppSchemeQrTest',
  AppSchemeQrAlpha = 'AppSchemeQrAlpha',
  AppSchemeQrSandbox = 'AppSchemeQrSandbox',
  AppSchemeQrQa = 'AppSchemeQrQa',
  AppSchemeQrBeta = 'AppSchemeQrBeta',
  AppSchemeQrReal = 'AppSchemeQrReal',
  // 모달 이미지
  ModalGiftStatic = 'ModalGiftStatic',
  ModalCashStatic = 'ModalCashStatic',
  ModalAppIconStatic = 'ModalAppIconStatic',
  LogoBiStatic = 'LogoBiStatic',
  HelixLandingBgV1Static = 'HelixLandingBgV1Static',
  HelixLandingBgStatic = 'HelixLandingBgStatic',

  ThumbnailEmptyCardStatic = 'ThumbnailEmptyCardStatic',
}
